import React, { useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Stack, Typography } from "@mui/material";

import useMutate from "../../../hooks/useMutate";
import { updatePlannerTokenSharing } from "../../../sevices/apiSystemSettings";
import { RFHToggle as RHFToggle } from "../../../components/RFH";
import { CustomButton } from "../../../components/Button/Button";
import { localStorageInstance } from "../../../utils/localStorage";

function PlannerSettings({ initialData }) {
  const methods = useForm({
    defaultValues: {
      planner_token_sharing_enabled:
        initialData?.planner_token_sharing_enabled ?? false,
    },
  });

  const { mutate, isPending } = useMutate(updatePlannerTokenSharing, [
   "tenant-details",
   "planner-token-sharing",
  ],() => {
   
  }
);

  const formValues = methods.watch();
  const initialValue = initialData?.planner_token_sharing_enabled ?? false;
  const isDirty = formValues?.planner_token_sharing_enabled !== initialValue;

  const onSubmit = useCallback(
    (formData) => {
      if (formData.planner_token_sharing_enabled === true) {
        localStorageInstance.removeItem("planner_user_id");
        localStorageInstance.removeItem("planner_refresh_token");
        localStorageInstance.removeItem("planner_access_token");
      // Also clear the "todos" query cache when enabling token sharing
      if (window?.__REACT_QUERY_CLIENT__) {
        window.__REACT_QUERY_CLIENT__.removeQueries(["todos"]);
      } else if (typeof window !== "undefined" && window.queryClient) {
        window.queryClient.removeQueries(["todos"]);
      }
      }
      mutate({
        planner_token_sharing_enabled: formData.planner_token_sharing_enabled,
      });
    },
    [mutate]
  );

  return (
    <>
      <FormProvider {...methods}>
        <div className="mt-32 form-section">
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <div>
              <Typography className="setting-heading mb-2 ml-0">
                Planner Settings
              </Typography>
            </div>
            <div className="d-flex mt-32 align-items-center">
              <div className="mr-4">
                <Typography className="setting-heading ml-0">
                When enabled, this planner is public. When disabled, it is private
                </Typography>
               
              </div>
              <div className="ml-2">
                <RHFToggle name="planner_token_sharing_enabled" />
              </div>
            </div>
            <Stack alignItems="end" className="mt-32">
              <CustomButton
                variant="contained"
                type="submit"
                className="theme-bg-color working-hours-update-button"
                disabled={isPending || !isDirty}
              >
                Update
              </CustomButton>
            </Stack>
          </form>
        </div>
      </FormProvider>
    </>
  );
}

export default React.memo(PlannerSettings);
